/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Styles

// JS
document.addEventListener("DOMContentLoaded", function(event) {
    if(document.querySelector(".toaster")){
        let toasterErr = document.querySelector(".toaster");
        toasterErr.classList.add("shown");
        setTimeout(() => {
            toasterErr.classList.remove("shown");
        }, 5000);

    }
    if(document.querySelector(".toaster-close")){
        document.querySelector(".toaster-close").addEventListener("click",()=>{
            document.querySelector(".toaster").classList.remove("shown");
        })
    }

    let passwordInput = document.querySelector("input[name='v1_user[password]']");
    let repeatPasswordInput = document.querySelector("input[name='v1_user[password_confirmation]']");
    let seePass = document.querySelectorAll(".see-pass");
    let checkSpecial = document.querySelector("ul li.check-special");
    let checkMin6 = document.querySelector("ul li.check-min-6");
    let checkCapital = document.querySelector("ul li.check-capital");
    let checkSmall = document.querySelector("ul li.check-small");

    let requirementsMet = {
        length: false,
        specialChar: false,
        capitalLetter: false,
        smallLetter: false
    };

    passwordInput.addEventListener("keyup",validatePassword);
    repeatPasswordInput.addEventListener("keyup",repeatPasswordCheck);
    seePass.forEach((item)=>{
        item.addEventListener("click",seePassword);
    })

    function validatePassword() {
        let password = passwordInput.value;
        let regexLength = /^.{6,}$/;
        let regexSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        let regexCapitalLetter = /[A-Z]/;
        let regexSmallLetter = /[a-z]/;

        if (password.match(regexLength)) {
            requirementsMet.length = true;
            checkMin6.classList.add("checked");
        } else {
            requirementsMet.length = false;
            checkMin6.classList.remove("checked");
        }

        if (password.match(regexSpecialChar)) {
            checkSpecial.classList.add("checked");
            requirementsMet.specialChar = true;
        } else {
            requirementsMet.specialChar = false;
            checkSpecial.classList.remove("checked");
        }

        if (password.match(regexCapitalLetter)) {
            checkCapital.classList.add("checked");
            requirementsMet.capitalLetter = true;
        } else {
            checkCapital.classList.remove("checked");
            requirementsMet.capitalLetter = false;
        }

        if (password.match(regexSmallLetter)) {
            checkSmall.classList.add("checked");
            requirementsMet.smallLetter = true;
        } else {
            checkSmall.classList.remove("checked");
            requirementsMet.smallLetter = false;
        }

        if (password === repeatPasswordInput.value && isRequirementsMet()) {
            document.querySelector("#submit-password").disabled = false;
        } else {
            document.querySelector("#submit-password").disabled = true;
        }
    }

    function repeatPasswordCheck(){
        if (passwordInput.value === repeatPasswordInput.value && isRequirementsMet()) {
            document.querySelector("#submit-password").disabled = false;
        } else {
            document.querySelector("#submit-password").disabled = true;
        }
    }

    function isRequirementsMet(){
        for (let requirement in requirementsMet) {
            if (!requirementsMet[requirement]) {
                return false;
            }
        }
        return true;
    }

    function seePassword(e) {
        let input = e.target.parentElement.querySelector("input");
        if(input.getAttribute("type") == "password"){
            input.setAttribute("type","text");
        }
        else{
            input.setAttribute("type","password");
        }
    }
});


